import { render, staticRenderFns } from "./VerticalText.vue?vue&type=template&id=450de114&scoped=true&"
import script from "./VerticalText.vue?vue&type=script&lang=js&"
export * from "./VerticalText.vue?vue&type=script&lang=js&"
import style0 from "./VerticalText.vue?vue&type=style&index=0&id=450de114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450de114",
  null
  
)

export default component.exports